import { Card, Button, Empty, message, List, Tag } from 'antd';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { RobotOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { $ } from '../lib/api';

export function AiCoachPage() {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ['my-coach-reports'], queryFn: () => $.get<any[]>('/ai-coach/my') });
  const gen = useMutation({
    // v1.5 真修 F5a：UI"立即生成"必须带 ?force=true 跳后端 cache 短路，否则一周内反复点都返第一次的 cached
    mutationFn: () => $.post('/ai-coach/generate?force=true'),
    onSuccess: () => { message.success('已生成'); qc.invalidateQueries({ queryKey: ['my-coach-reports'] }); },
  });
  const latest = data?.[0];
  return (
    <div>
      <div style={{ marginBottom: 12, textAlign: 'right' }}>
        <Button type="primary" icon={<RobotOutlined />} loading={gen.isPending} onClick={() => gen.mutate()}>
          立即生成本周报告
        </Button>
      </div>
      {!latest ? <Empty description="还没有 AI 教练报告，点击右上方按钮立即生成" /> : (
        <Card title={`🎓 AI 教练 · ${latest.weekStart} - ${latest.weekEnd}`}>
          <h3>📊 本周亮点</h3>
          <ul>{(latest.highlights ?? []).map((h: string, i: number) => <li key={i}>{h}</li>)}</ul>
          <h3>⚠️ 需要改进</h3>
          <ul>{(latest.improvements ?? []).map((h: string, i: number) => <li key={i}>{h}</li>)}</ul>
          <h3>💡 学习推荐</h3>
          <ul>{(latest.recommendations ?? []).map((h: string, i: number) => <li key={i}>{h}</li>)}</ul>
          <h3>🎯 本周优先做</h3>
          <ul>{(latest.priorityActions ?? []).map((h: string, i: number) => <li key={i}>{h}</li>)}</ul>
        </Card>
      )}
      <Card title="历史报告" style={{ marginTop: 16 }}>
        <List
          dataSource={data ?? []}
          renderItem={(r: any) => (
            <List.Item>
              <List.Item.Meta
                title={<>{r.weekStart} - {r.weekEnd} {r.readAt ? <Tag>已读</Tag> : <Tag color="blue">未读</Tag>}</>}
                description={r.summary}
              />
            </List.Item>
          )}
        />
      </Card>
    </div>
  );
}
